import React from "react";
import { Grid } from "@mui/material";
import { ToggleTitleWrapper } from "../styled/ToggleTile.styled";
import { ToggleSwitch } from "../styled/ToggleTile.styled";

export default function SitesAreaFilter({
  siteAreaToggle,
  appliedFilters,
  onChangeGeoAreaFilter,
}) {
  return (
    <Grid
    container
    xs={12}
    sm={12}
    md={12}
    item
    style={{
      justifyContent: "space-between",
      margin: "15px 5px 0px",
      padding: "10px",
      font: "normal normal 550 13px/18px Open Sans",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      border: "1px solid #007842",
      borderRadius: "5px",
      opacity: "1",
    }}
  >
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      item
      style={{
        justifyContent: "space-between",
        marginTop: "5px",
      }}
    >
      <ToggleTitleWrapper>
        Apply Geographical Area<br />Filter
      </ToggleTitleWrapper>
      <ToggleSwitch
        checked={siteAreaToggle}
        onChange={() => {
          onChangeGeoAreaFilter();
        }}
        disabled={!appliedFilters.level}
      />
    </Grid>
  </Grid>
  );
}

